/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react'
import { Form, Input, Modal, notification } from 'antd'
import { useDispatch, useSelector } from 'react-redux'

import { unwrapResult } from '@reduxjs/toolkit'
import { RootDispatch } from '../../app/store'
import { PlusOutlined, MinusOutlined } from '@ant-design/icons'
import styles from '../followUp/addFollowUp.module.css'
import cnchar from 'cnchar'
import { stringTrim } from '../../utils/StringUtils'
import { deleteSettingLableAsync, getLableListAsync, saveSettingLableAsync } from './setmealSlice'

export const SettingLables = (props: {
  visible: boolean
  refresh: () => void
  onOk: () => void
  onCancel: () => void
}) => {
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const [lableList, setLableList] = useState<any>()

  const [indexs, setIndex] = useState(0)

  const labelData = lableList?.map((v: any) => {
    return v?.name
  })

  const getLableList = () => {
    dispatch(getLableListAsync())
      .then(unwrapResult)
      .then((v: any) => {
        setLableList(v)
      })
  }

  useEffect(() => {
    if (props?.visible){
      getLableList()
    }
  }, [dispatch, props?.visible])

  useEffect(() => {
    if (labelData?.length) {
      form.setFieldsValue({
        label: [...labelData],
      })
    } else {
      form.setFieldsValue({
        label: [''],
      })
    }
  }, [lableList])

  return (
    <div>
      <Modal
        className={styles.model}
        title={'标签设置'}
        visible={props.visible}
        okText='确认'
        cancelText='取消'
        onOk={() => {
          form.validateFields().then((values) => {
            const value = Object.values(values).flat(2)
            const index = value.findIndex((v) => v === '' || v === undefined)
            const newDate = index === -1 ? value : value.slice(0, index)
            const param: any = newDate?.map((v, index) => {
              return [{ name: v, id: lableList[index]?.id }]
            })
            dispatch(saveSettingLableAsync(param?.flat(1)))
              .then(unwrapResult)
              .then(() => {
                notification.success({ message: '保存成功', duration: 3 })
                props?.refresh()
              })
              .catch(() => {
                notification.error({ message: '保存失败', duration: 3 })
              })
            form.resetFields()
            props.onOk()
          })
        }}
        onCancel={() => {
          props?.refresh()   //更新数据
          form.resetFields()
          props.onCancel()
          form.setFieldsValue({
            treatmentParts: [''],
          })
        }}
        width='450px'
      >
        <Form
          name='dynamic_form_item'
          form={form}
          autoComplete='off'
          onFinish={(vs) => {
            form.resetFields()
            props.onOk()
          }}
        >
          <Form.List
            name='label'
            rules={[
              {
                validator: async (_, followUpType) => {
                  if (!followUpType || followUpType.length < 1) {
                    return Promise.reject(new Error('标签不能为空'))
                  }
                },
              },
            ]}
          >
            {(fields: any, { add, remove }) => {
              return (
                <>
                  {fields.map((field: any, index: any) => (
                    <Form.Item
                      className={styles.name}
                      style={{ marginLeft: '20px' }}
                      label={'标签' + (index + 1)}
                      required
                      key={field.key}
                    >
                      <Form.Item
                        {...field}
                        required
                        getValueFromEvent={stringTrim}
                        validateTrigger={['onChange', 'onBlur']}
                        rules={[
                          {
                            ...(fields.length > 1
                              ? {
                                required: true,
                                message: '标签大于一条时不能为空',
                              }
                              : ''),
                          },
                        ]}
                        noStyle
                      >
                        <Input
                          placeholder='请输入标签'
                          style={{ width: '60%' }}
                          maxLength={25}
                          onChange={(e) => {
                            setIndex(index)
                          }}
                        />
                      </Form.Item>
                      {fields.length > 1 ? (
                        <a
                          className={styles.add}
                          onClick={() => {
                            let tempFlag;
                            form.getFieldsValue(true).label.forEach((item: any, num: number) => {
                              if (index == num && !item) {
                                tempFlag = true
                                remove(num)
                                notification.success({
                                  message: '删除成功',
                                  duration: 3,
                                })
                                return
                              }
                            })
                            if (tempFlag) return
                            remove(field.name)
                            const param = {id : lableList?.[index]?.id}
                            dispatch(deleteSettingLableAsync(param))
                              .then(unwrapResult)
                              .then(() => {
                                notification.success({
                                  message: '删除成功',
                                  duration: 3,
                                })
                              getLableList()
                              })
                          }}
                        >
                          <MinusOutlined
                            style={{ marginLeft: '10px', color: '#101010' }}
                          />
                        </a>
                      ) : null}
                      {fields.length === index + 1 ? (
                        <a onClick={() => add()}>
                          <PlusOutlined
                            style={{ marginLeft: '10px', color: '#101010' }}
                          />
                        </a>
                      ) : null}
                    </Form.Item>
                  ))}
                  <Form.Item></Form.Item>
                </>
              )
            }}
          </Form.List>
        </Form>
      </Modal>
    </div>
  )
}
